export default __webpack_public_path__ + "static/media/avichai-shtern.b258d7db.png";